// 
// ----------- Import images ----------- //
// 
// Work [0]: The Movie Base
import movieBaseMockup from '../media/images/the-movie-base-mockup.jpg';
import movieBaseFinal1 from '../media/images/moviebase-iPhone-Mockup.jpg';
import movieBaseFinal2 from '../media/images/moviebase-iPad-Mockup.jpg';
import movieBaseFinal3 from '../media/images/moviebase-macbook-Mockup.jpg';
import movieBaseMoodboard from '../media/images/the-movie-base-moodboard.png';
import movieBaseHFMockup1 from '../media/images/the-movie-base-mockup1.jpg';
import movieBaseHFMockup2 from '../media/images/the-movie-base-mockup2.jpg';

// Work [1]: Velou Hair Boutique
import velouMockup from '../media/images/velou-mockup.jpg';
import velouIA from '../media/images/velou-ia.jpg'
import velouMockup1 from '../media/images/velou-mockup1.png';
import velouMockup2 from '../media/images/velou-mockup2.png';
import velouMockup3 from '../media/images/velou-mockup3.png';

// Work [2]: Portfolio Website
import portfolioMockup from '../media/images/portfolio-mockup.jpg';
import portfolioWF1 from '../media/images/portfolio-wireframe1.jpg';
import portfolioWF2 from '../media/images/portfolio-wireframe2.jpg';

// Work [3]: JS Game
import jsGameMockup from '../media/images/jsgame-mockup.jpg';
import jsGameGIF from '../media/images/jsgame-final.gif';
import jsGameFlow from '../media/images/jsgame-gameflow.png';
import jsGameWF1 from '../media/images/jsgame-wireframe1.png';
import jsGameWF2 from '../media/images/jsgame-wireframe2.png';
import jsGameBoard from '../media/images/jsgame-gameboard.jpg';
import jsGameIcons from '../media/images/jsgame-icons.jpg';


import { APP_URL, URL_PREFIX, URL_SUFFIX } from '../globals/variables';

// 
// ----------- Array of Works information ----------- //
// 

const works = [
    {
        title: 'The Movie Base',
        url: '/work/the-movie-base',
        type: 'Movie Database',
        exerpt: 'A movie database website designed to provide users with latest movie information.',
        thumbnail: movieBaseMockup,
        links: {
            liveSite: URL_PREFIX + 'movie-base' + URL_SUFFIX
        },
        overview: 'The Movie Base is a single page React web app that enables users to keep track of trending movies. The Movie Base utilizes REST API to help in displaying movie ratings, release date, plot summaries, and movie genre.',
        skills: [ 'React', 'HTML5', 'CSS3', 'Adobe XD', 'Adobe Photoshop', 'Adobe Illustrator'],
        finalProduct: {
            heading: "Final Product",
            text: 'Responsive design that is accessibly for mobile, tablet and desktop devices',
            images: [movieBaseFinal1, movieBaseFinal2, movieBaseFinal3]
        },
        contents: [
            {
                section: 'Design Process',
                text: 'The designing process of this website started with the brainstorming of ideas through mood board by comparing the use of colors, typography and logo which are elememts that determines the style. High fidelity mockup and interactive prototype are produced with Photoshop and Adobe XD. Responsiveness and accesibilty are highly considered to ensure a great user experience.',
                images: [ 
                    { 
                        source: movieBaseMoodboard,
                        alt: 'Movie Base Moodboard'
                    }, 
                    {
                        source: movieBaseHFMockup1,
                        alt: 'High Fidelity Mobile Mockup'
                    }, 
                    {
                        source: movieBaseHFMockup2,
                        alt: 'High Fidelity Desktop Mockup'
                    }
                ]
            },
            {
                section: 'Color',
                text: 'A mainly dark background is used here to create a theatre-like atmosphere. A pair of invert accent color that is slightly pastle is used give users a more comfortable experience when browsing',
                colors: [
                    {
                        colorname: 'Vampire Black',
                        colorcode: '#08090b'
                    },
                    {
                        colorname: 'Blue Sapphire',
                        colorcode: '#326273'
                    },
                    {
                        colorname: 'Dark Salmon',
                        colorcode: '#e39774'
                    },
                    {
                        colorname: 'Cultured',
                        colorcode: '#eeeeee'
                    }
                ]
            },
            {
                section: 'Development Process',
                text: 'The Movie Base is the first web application that I have developed using ReactJS framework. Utilizing functional components and React Routing, I ensured smooth data communication within the project. Favourited movies can be added through local storage, and displayed on a dedicated page. Furthermore, with the help of Rest API, I incorporated the “All Genre” functionality that allows users to filter between genres to receive movie recommendations that suit their needs.',
                images: [movieBaseMockup]
            }
        ]
    },
    {
        title: 'Velou Hair Boutique',
        url: '/work/velou-hair-boutique',
        type: 'WordPress',
        exerpt: 'An E-commerce website for a luxury hair studio brand developed with WordPress in a team based setting.',
        thumbnail: velouMockup,
        links: {
            liveSite: 'https://google.com'
        },
        overview: 'In a team-based setting, an E-commerce website is designed and developed for a fictional hair salon, Velou Hair Boutique. This website is developed with WordPress customized for the need of a hair solon. Project management tools are utilized to keep track of the progress, tasks and schedules.',
        skills: [ 'WordPress', 'PHP', 'Sass', 'GitHub', 'InVision', 'Figma', 'Asana'],
        team: [ 'Kirsten Kwan', 'Elena Diana Ungureanu', 'Jihye Cho', 'Tiffany Lee'],
        contents: [
            {
                section: "Initial Planning",
                text: 'At the startup stage of the project, our team has put much effort on identifying the target audience, potential competitors and what the users would be able to do on the website. We have also done massive research on simlilar businesses. Through the discovery meeting, we have made decisions on the branding of the salon, the requirements, and the content and features that would be on the website.'

            },
            {
                section: "Development Plan",
                text: 'The next step was creating plans for the development including the Content Plan and Information Architecture. The purpose was to make decisions on the site structure and the contents of each page. We have also done plannings on the content management and content storage and summarized as a development plan.',
                images: [
                    { 
                        source: velouIA,
                        alt: 'Velou Information Architecture'
                    }, 
                ]
            },
            {
                section: 'Creative Process',
                text: 'As a collaboration project, our team created a low fidelity wireframe half way through the planning process which helped us a lot on the communication of ideas and finalizing details. Spliting the team into half, I was one of the members responsible for creating the design mockup while the other half started on the development process. During brainstorming, moodbaords are created followed by the high fidelity mobile and desktop mockups using Figma.',
                images: [
                    { 
                        source: velouMockup1,
                        alt: 'Velou Service Page Mockup'
                    }, 
                    {
                        source: velouMockup2,
                        alt: 'Velou Contact Page Mockup'
                    },
                    {
                        source: velouMockup3,
                        alt: 'Velou Gallery Page Mockup'
                    }
                ],
            },
            {
                section: 'Color',
                text: 'A set of natural color palatte hinted Velou is a hair boutique that values natural environment.',
                colors: [
                    {
                        colorname: 'Morning Blue',
                        colorcode: '#9BA59E'
                    },
                    {
                        colorname: 'Light Gray',
                        colorcode: '#D0D4D0'
                    },
                    {
                        colorname: 'Platinum',
                        colorcode: '#EDE8E5'
                    },
                    {
                        colorname: 'Pastel Gray',
                        colorcode: '#D2C7C1'
                    },
                    {
                        colorname: 'Silver Pink',
                        colorcode: '#BEB0A8'
                    }
                ]
            },
            {
                section: 'Development Process',
                text: 'This E-commerce website aims to allow the fictional client to constantly update contents and manage bookings, which is highly related to he content storage that we have setup. The developement process has version controls throughout with the use of GitHub.',
                images: [movieBaseMockup]
            }
        ]
    },
    {
        title: 'Portfolio Website',
        url: '/work/portfolio-website',
        type: 'Portoflio',
        exerpt: 'A portfolio website developed to showcase work of my own and as a platform to connect to the society.',
        thumbnail: portfolioMockup,
        links: {
            liveSite: APP_URL
        },
        overview: 'This is my professional portfolio built in React. It not only showcases my work and experience in web development, but also delivers my concept of clean and responsive UI design. ',
        skills: [ 'React', 'JavaScript', 'HTML5', 'Sass', 'Adobe XD'],
        contents: [
            {
                section: 'Design Process',
                text: 'As a website that showcases my work and personality, I have reasearched a lot on how to structure and deliver the contents. I also considered a lot on the characterics to show, and decided to use flat-layed line graphics to feature throughout the website. This concept gives a clean UI that uses white space and effectively highlights that messages that I wish to deliver.',
                images: [
                    { 
                        source: portfolioWF1,
                        alt: 'Portfolio Wireframe'
                    }, 
                    {
                        source: portfolioWF2,
                        alt: 'Portfolio Wireframe'
                    }
                ]
            },
            {
                section: 'Color',
                text: 'This website is designed to use mainly black and white with a little bit of accent colors to highlight.',
                colors: [
                    {
                        colorname: 'Raisin Black',
                        colorcode: '#27272B'
                    },
                    {
                        colorname: 'Platinum',
                        colorcode: '#ebeced'
                    },
                    
                    {
                        colorname: 'Cade Blue Crayola',
                        colorcode: '#afbbc4'
                    },
                    {
                        colorname: 'Independence',
                        colorcode: '#4c586f'
                    },
                    
                ]
            },
            {
                section: 'Development Process',
                text: 'The structuring of components as well as the storage and utilization of data are some of the main objectives of the development process. Since there are similar sections under each work to showcase, I chose a data-driven appoach by reusing components and feeding in data that has an organized structure.',
                images: [ movieBaseMockup]
            }
        ]
    },
    {
        title: 'Photographic Memory',
        url: '/work/photographic-memory',
        type: 'JavaScript Game',
        exerpt: 'A well known game created with JavaScript, designed in the theme of Japanese New Year.',
        thumbnail: jsGameMockup,
        links: {
            gitHub: 'https://github.com/kirstenkwan'
        },
        overview: 'The Photographic Memory Game is a memorization game developed based on jQuery library. Players can play through different difficulty levels solo or compete with friends in different game mode. Players are also able to experience the great UI design benefited from thorough initial planning. ',
        skills: [ 'JavaScript', 'jQuery', 'HTML5', 'CSS3', 'Adobe XD'],
        finalProduct: {
            heading: "Final Product",
            text: 'Smooth game flow and high input responsiveness creates good user experences.',
            images: [jsGameGIF]
        },
        contents: [
            {
                section: 'Planning',
                text: 'In this game project, my goal is to deliver an user-oriented game experience which allows users to have an intuitive and smooth game flow. Therefore, extensive planning was done including the game behaviour, game page transition and user inputs',
                images: [
                    { 
                        source: jsGameFlow,
                        alt: 'Photographic Memory Game Flow'
                    }, 
                    {
                        source: jsGameWF1,
                        alt: '3 Players Mode Wreframe'
                    }, 
                    {
                        source: jsGameWF2,
                        alt: 'Game Over Screen Wireframe'
                    }
                ]
            },
            {
                section: 'Design Concept',
                text: 'Using linear colored icons was the inital idea for the game board design. Combining with traditional asian cultures, I have chosen Japanese New Year as the theme, which shows a lot of the traditions or symbols that was inherited from the old times.',
                images: [
                    { 
                        source: jsGameBoard,
                        alt: 'Photographic Memory Game Board'
                    }, 
                    {
                        source: jsGameIcons,
                        alt: 'Icons used on game board'
                    }
                ]
            },
            {
                section: 'Development Process',
                text: 'Photographic Memory Game was thoroughly scoped and planned. Details including game modes, difficulty levels, player interactions, timer count down for different levels, and game flows were all well-designed at the initial stage of development. <br/>  Utilizing techniques like DOM elements manipulation, randomly assigned game board is available on demand. Players will experience new challenges in every game.',
                images: ['']
            }
        ]
        
    }
]

export default works;